import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import Route from 'route-parser';
// import Axios from 'axios';
// import {
//   editInventoryManagementRoute,
//   // inventoryManagementRoute,
//   // accountAdminRoute,
// } from '../../../config/navigation/routes';
import { editInventory } from './graphql';
import getCodeDefinitions from '../../../graphql/codeDefinitions';
import { inventoryById } from '../../../graphql/item';
// import { forwardTo } from '../../../utils/browserHistoryUtils';

export default function EditInventoryManagementHOC(EditInventoryManagementPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        email: PropTypes.string,
        cageCode: PropTypes.string,
      }).isRequired,
      selectedItemId: PropTypes.string.isRequired,
      showEditModal: PropTypes.bool.isRequired,
      closeEditModal: PropTypes.func.isRequired,
      reloadItems: PropTypes.func.isRequired,
    };

    static initialState = {
      formValues: {
        ui: {
          selectValueA: '',
          selectValueACopy: '',
          displayValues: [],
        },
        qup: {
          selectValueC: '',
          selectValueCCopy: '',
          displayValues: [],
        },
        visibility: {
          selectValueB: '',
          selectValueBCopy: '',
          displayValues: [],
        },
      },
      isLoading: true,
      errors: [],
      message: '',
      type: '',
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const {
        inventoryById: { item },
      } = await inventoryById(this.props.selectedItemId);

      const uiOptions = this._createOptions(await getCodeDefinitions("UI"));
      const qupOptions = this._createOptions(await getCodeDefinitions("QUP"));

      this.setState({
        formValues: {
          ui: {
            selectValueA: item.ui,
            selectValueACopy: item.ui,
            displayValues: uiOptions,
          },
          qup: {
            selectValueC: item.qup,
            selectValueCCopy: item.qup,
            displayValues: qupOptions,
          },
          visibility: {
            selectValueB: item.visibility,
            selectValueBCopy: item.visibility,
            displayValues: [
              {
                value: true,
                text: 'Public'
              }, {
                value: false,
                text: "Gov't Only"
              }
            ],
          },
          id: item.id,
          niin: item.niin,
          partNum: item.partNum,
          description: item.description,
          price: item.price,
          soh: item.soh,

        },
        isLoading: false,
      });

      const formValues = { ...this.state.formValues };
      this.setState({ formValues });
    }

    _createOptions = arr => {
      const options = arr.map(code => ({ text: code.codeDefinition, value: code.codeValue }));
      return options;
    };


    _onSubmit = async event => {
      console.log("onsubmit is called")
      const { organizationId, email, cageCode } = this.props.auth;
      const { selectedItemId } = this.props;

      const obj = {
        ...event,
      };

      obj.ui = obj.ui.selectValueA;
      obj.qup = obj.qup.selectValueC;
      obj.visibility = obj.visibility.selectValueB;
      obj.modifiedBy = email;

      try {
        const { updateInventory } = await editInventory({
          id: selectedItemId,
          ...obj,
          organizationId,
          cage: cageCode,
        });

        if (updateInventory.status === 'success') {
          this.setState({
            message: 'Inventory Management Updated!',
            type: 'success',
          });
          // NFFS-442
          setTimeout(() => { this.props.closeEditModal(); this.props.reloadItems() }, 1000);
        } else {
          this.setState({
            message: 'Unable to update inventory. Please try again in a few minutes',
            type: 'warning',
          });
        }
      } catch (error) {
        this.setState({
          message: 'Unable to update inventory.',
          type: 'warning',
        });
      }
    };

    _handleInitalValueReset = () => {
      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };
      formValues.ui.selectValueA = this.state.formValues.ui.selectValueACopy;
      formValues.qup.selectValueC = this.state.formValues.qup.selectValueCCopy;
      formValues.visibility.selectValueB = this.state.formValues.visibility.selectValueBCopy;
      this.setState({ formValues });
    };

    render() {
      const { formValues, isLoading, errors, message, type } = this.state;
      const { showEditModal, closeEditModal } = this.props;

      // Configure Page
      const pageProps = {
        formValues,
        isLoading,
        onSubmit: this._onSubmit,
        handleInitalValueReset: this._handleInitalValueReset,
        optionsAccessLevelData: this._optionsAccessLevelData,
        optionsCategoryData: this._optionsCategoryData,
        errors,
        message,
        type,
        showEditModal,
        closeEditModal,
      };

      return <EditInventoryManagementPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/Modals/EditInventoryManagement/EditInventoryManagementHOC.jsx